import React, {Component} from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import Config from '../config';
import {
    Page,
    Preload,
    FollowLiveroom,
} from '../components'
import '../styles/recorddetaillist/FollowRecordPage.css'
import {
    Flex,
    FlexItem,
    LoadMore,
    ActionSheet,
} from 'react-weui';
import {isLZWKAPP, shouldLinkToAPP, isLZWKAPPIpad, isFromCPSLiveroom, setEvent} from '../utils'
import { WKVisible } from '../components/wk'
import onRecordImg from '../images/no-record-data.png'
import { Dialog } from '../components/dialog'
import hand from '../images/hand.png'
import {getAccessToken} from '../utils'

class FollowRecordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            liverooms: [],
            initialized: false,
            hasMore: false,
            nextOffset: 0,
            loading: false,
            showCancel: false,
            hasLiveroom: false,
            menus: [{
                label: '不再关注',
                onClick: this.handleUnFollow.bind(this),
                className: 'unfollow-button cursor-pointer',
            }],
            actions: [{
                label: '关闭',
                onClick: this.hideActionSheet.bind(this),
                className: 'cursor-pointer',
            }],
            dialogConfig: {},
            isDialogShow: false,
            hasShowTeacherButtom: false,
            isWhiteUser: false
        }
        this.handleLoadMoreData = this.handleLoadMoreData.bind(this)
        this.handleRefresh = this.handleRefresh.bind(this)
        this.personVerifyIcon = 'https://img.lycheer.net/material/59358349/5ce27b4ba444135a0b19ccb6.png'
        this.companyVerifyIcon = 'https://img.lycheer.net/material/59358349/5ce27b4bac80a01a7bbb908a.png'
    }

    hideActionSheet() {
        this.setState({
            showCancel: false,
        });
    }

    handleLoadMoreData() {
        this.setState({loading: true})
        axios.get(`/api/history/follow_record`, {params: {offset: this.state.nextOffset}}).then((response) => {
            const {liverooms, has_more, next_offset} = response.data.data
            liverooms.map((item) => (item.isFans = true))
            if (response.data.code === 0) {
                let newLiverooms = [...this.state.liverooms, ...liverooms];
                this.setState({
                    liverooms: newLiverooms,
                    initialized: true,
                    hasMore: has_more,
                    nextOffset: next_offset,
                    loading: false,
                });
                if (newLiverooms.length <= 0) {
                    let href = '/';
                    if (shouldLinkToAPP()){
                        href = 'lizhiweike://home';
                    }
                    this.props.dispatch({
                        type: 'ERROR_SHOW',
                        payload: {
                            tips: '我关注的直播间空空如也~',
                            img: onRecordImg,
                            href: href,
                            btn: (isLZWKAPP() || isLZWKAPPIpad()) ? '' : '回首页看看',
                        }
                    });
                }
            }
        });
    }

    async getWhiteListBatch(params) {
        try {
          const token = getAccessToken();
          return axios
            .post(
              `${Config.gateway_root_url}/config/check_whitelist_batch?version=1.0`,
              params,
              { headers: { 'Content-Type': 'application/json' }, params: { token } },
            )
            .then(res => {
                this.setState({ isWhiteUser: res.data.data.is_create_saas3 })
            })
            .catch(err => {
                console.log(err)
            })
        } catch (e) {
          console.error(e.message);
        }
      }

    handleRefresh() {
        window.location.reload();
    }

    toCreateLive(){
        setEvent('fe_fr_cl_ck')
        location.assign('/management/liveroom/first-create?lecture_mode=live_v&from=fe_af_wyzb')
    }

    handleToggleFollow(item) {
        const {liverooms} = this.state
        if (item.isFans) {
            this.item = item;
            this.setState({
              isDialogShow: true,
              dialogConfig: {
                title: '是否不再关注该直播间',
                text: ['取消', '不再关注'],
                onCancel: () => {
                  this.setState({
                    isDialogShow: false
                  })
                },
                onSubmit: () => {
                    this.handleUnFollow()
                    //this.setState({isDialogShow: false})
                }
              }
            })
            // this.setState({showCancel: true})
        } else {
            this.props.dispatch({
                type: 'SHOW_FOLLOW_LIVEROOM',
                payload: {
                    liveroom: item,
                    callback: () => {
                        let newLiverooms2 = liverooms.map((liveroomItem) => {
                            if (liveroomItem.id === item.id) {
                                liveroomItem.isFans = true
                            }
                            return liveroomItem;
                        });
                        this.setState({liverooms: newLiverooms2});
                    },
                },

            });
            
        }
    }

    handleUnFollow() {
        const {liverooms} = this.state
        axios.post(`api/liveroom/${this.item.id}/unfollow`).then((response) => {
            if (response.data.code === 0) {
                let newLiverooms = liverooms.map((liveroomItem) => {
                    if (liveroomItem.id === this.item.id) {
                        liveroomItem.isFans = false
                    }
                    return liveroomItem;
                });
                this.setState({liverooms: newLiverooms});
            }
        });
        this.setState({
            showCancel: false,
            isDialogShow: false
        })
    }

    gethasLiveroomStatus = () => {
        axios.get('/api/account/has_liveroom').then(({data: { data: { has_liveroom } } }) => {
            if(has_liveroom) {
                this.setState({
                    hasLiveroom: has_liveroom
                })
            }

            if (!has_liveroom){
                setEvent('fe_fr_wyzb_btn_v')
            }
        })
    }

    componentDidMount() {
        document.title = '我的关注'
        this.handleLoadMoreData()
        this.getWhiteListBatch({
            liveroom_id: 0,
            batch: {
                is_create_saas3: {
                server_name: 'liveroom_model',
                key: 'h5_weike3_whitelist',
              },
            },
          })
        this.gethasLiveroomStatus()
    }

    handleScrollTop() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
    }

    becomeTeacher(){
        if(!this.state.hasShowTeacherButtom){
            window.gio && window.gio("track","myfollow_teacherbutton_by_eject")
            this.setState({hasShowTeacherButtom: true})
        }
        return <div className="create-my-class"
            onClick={() => {
                window.gio && window.gio("track","myfollow_teacherbutton_by_click");
                location.assign(this.state.isWhiteUser ? '/management/create-store?fromPage=toTeacher' : '/management/liveroom/first-create')
            }}>
            <p>成为讲师</p>
            <img src={hand} alt=""/>
        </div>
    }

    render() {
        const {initialized, liverooms, hasMore, loading, menus, actions, showCancel, hasLiveroom} = this.state
        const {error} = this.props

        if (!initialized) {
            return <Preload/>
        }
        if (error.showError) {
            return (
                <div className="sharecard-slide-page_error">
                    <WKVisible create={!(isLZWKAPP() || isLZWKAPPIpad())}>
                        <div className="follow-record-page-title">
                            <span onClick={this.handleRefresh}>我关注的直播间</span>
                            {!hasLiveroom && <span className="follow-record-page--mini-btn" onClick={this.toCreateLive}>
                              我要直播
                          </span>}
                        </div>
                    </WKVisible>

                    { !isFromCPSLiveroom() && <div className={`details-none-item`}>
                        <div className="item__img">
                            <img src="https://static-1253442168.file.myqcloud.com/xupload/20190430_pic-wnr.png" alt=""/>
                        </div>
                        <div className="item__text">
                            <div className="text__line">暂无关注的直播间</div>
                            <div className="text__line">快去首页发现更多的内容吧</div>
                        </div>
                        <div 
                          className={"weike__ui__primary"} 
                          onClick={() => window.location = error.href}
                        >
                            回首页看看
                        </div>
                    </div>
                    }
                    {/* {isTest && !isLZWKAPP() && !hasLiveroom && !location.href.includes('is_promote_flag') && <div 
                className="create-my-class"
                onClick={() => location.assign('/liveroom/first-create')}>
                <p>成为讲师</p>
                <img src={hand} alt=""/>
                </div>} */}
                </div>
            )
        }
        return (
            <Page className="follow-record-page ">
                <FollowLiveroom/>
                <div className="follow-record-page-div">
                    <WKVisible create={!(isLZWKAPP() || isLZWKAPPIpad())}>
                      <div className="follow-record-page-title">
                        <span onClick={this.handleRefresh}>
                          我关注的直播间
                        </span>
                          {!hasLiveroom && <span className="follow-record-page--mini-btn" onClick={this.toCreateLive}>
                              我要直播
                          </span>}
                      </div>
                    </WKVisible>
                    <div className="follow-record-page-list">
                        {
                            liverooms.map((item, index) => {
                                return (
                                    <div className="follow-record-page-item" key={item.id}>
                                        <a className="follow-record-page-flex" 
                                            href={!shouldLinkToAPP() ?
                                                `${Config.MAIN_URL}/liveroom/${item.id}${location.search}`
                                                : `lizhiweike://liveroom?liveroom_id=${item.id}`}
                                                data-id={item.id}
                                        >
                                            <Flex>
                                                <FlexItem className='follow-record-page-item-img'>
                                                    <div className="follow-record-page-img"
                                                         style={{backgroundImage: `url(${item.avatar_url})`}}>
                                                    </div>
                                                    {  (item.verify_type === 1 || item.verify_type === 2) ?
                                                        <div 
                                                           className="fllow-record-page-verify-icon"
                                                           style={{
                                                               backgroundImage: `url(${
                                                                   item.verify_type === 1 ? 
                                                                     this.personVerifyIcon : 
                                                                     this.companyVerifyIcon})`
                                                            }}
                                                        >
                                                        </div>  :
                                                        null 
                                                    }
                                                </FlexItem>
                                                <FlexItem className="follow-record-page-item-content"
                                                        //   onClick={this.handleScrollTop.bind(this)}
                                                >   
                                                    <ul className="follow-record-page-ul">
                                                        <li className="follow-record-page-li-first follow-record-page-font">{item.name}</li>
                                                        <li className="follow-record-page-li-second follow-record-page-font">{item.description}</li>
                                                    </ul>
                                                </FlexItem>
                                                <FlexItem className="follow-record-page-item-button-item ">
                                                    <div
                                                      onClick={(e)=>{
                                                        this.handleToggleFollow(item)

                                                        e.preventDefault()
                                                        e.stopPropagation()
                                                      }}
                                                      className={
                                                          item.isFans ? 
                                                            "new-unfollow-button" : 
                                                            "new-unfollow-button new-follow-button"
                                                      }
                                                    >
                                                      {item.isFans ? '取消关注' : '关注'}
                                                    </div>
                                                    {/* <Button
                                                        type="primary" plain
                                                        className={item.isFans ? "follow-record-page-item-button follow-record-page-button-unfollow" : "follow-record-page-item-button"}
                                                        onClick={this.handleToggleFollow.bind(this, item)}>
                                                        {item.isFans ? '已关注' : '关注'}
                                                    </Button> */}
                                                </FlexItem>
                                            </Flex>
                                        </a>
                                    </div>
                                )
                            })
                        }
                    </div>
                    {hasMore ?
                      <div className="footer">
                      {
                        loading ?
                        <LoadMore loading>正在加载</LoadMore>
                        :
                        <div className="view-more" onClick={this.handleLoadMoreData}>查看更多</div>
                      }
                      </div>
                        :
                        // <LoadMore showLine className="no-more">没有更多内容了</LoadMore>
                        null
                    }
                </div>
                <ActionSheet
                    menus={menus}
                    actions={actions}
                    show={showCancel}
                    type="ios"
                    onRequestClose={this.hideActionSheet.bind(this)}
                />
                <Dialog 
                  show={this.state.isDialogShow} 
                  dialogConfig={this.state.dialogConfig}
                >
                </Dialog>

                {!(isLZWKAPP() || isLZWKAPPIpad()) && !hasLiveroom && !location.href.includes('is_promote_flag') && this.becomeTeacher()}
            </Page>
        );
    }
}

FollowRecordPage.contextTypes = {
    page: React.PropTypes.object
};

export default connect((state) => ({
    error: state.error,
}))(FollowRecordPage)



// WEBPACK FOOTER //
// ./src/pages/FollowRecordPage.js